"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Direction = void 0;
var Direction = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL'
};
exports.Direction = Direction;


//////////////////
// WEBPACK FOOTER
// ./~/react-player-controls/dist/constants.js
// module id = 206
// module chunks = 168707334958949